import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "home-menu" }
const _hoisted_2 = { class: "menu-title wrap-text" }
const _hoisted_3 = { class: "menu-title-label wrap-text" }
const _hoisted_4 = { class: "menu-item-text wrap-text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "menu-item-top-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_menu, {
      mode: "inline",
      "default-selected-keys": [_ctx.currentPath],
      onSelect: _ctx.handleMenuSelect,
      openKeys: _ctx.openKeys,
      "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKeys) = $event)),
      selectedKeys: _ctx.selectedKeys,
      "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (route) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (route.children && route.children.length > 0)
              ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                  key: route.url
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      (route?.icon)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIconComponent(route?.icon)), { key: 0 }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_3, _toDisplayString(route.label), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.children, (childRoute) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: childRoute.url
                      }, [
                        (_openBlock(), _createBlock(_component_a_menu_item, {
                          to: childRoute.url,
                          key: childRoute.url
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(childRoute.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              : (route.url != '/')
                ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                    key: route?.url
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "menu-item-top wrap-text",
                        onClick: _withModifiers(($event: any) => (_ctx.handleMenuSelect({ key: route.url })), ["stop"])
                      }, [
                        (route?.icon)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIconComponent(route?.icon)), {
                              key: 0,
                              class: "menu-item-icon"
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(route.label), 1)
                      ], 8, _hoisted_5)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_a_menu_item, {
                        to: route.url,
                        key: route?.url,
                        style: {"display":"none"}
                      }, null, 8, ["to"]))
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]),
      _: 1
    }, 8, ["default-selected-keys", "onSelect", "openKeys", "selectedKeys"])
  ]))
}